import { useContext } from 'react';
import { NotificationContext, NotificationContextType } from '../context/notification.context';

const useNotifications = (): NotificationContextType => {
    const state = useContext(NotificationContext);
    return state;
};

export default useNotifications;
